export const PageHero = ({ eyebrow, title, subtitle, image, testId = "page-hero" }) => (
  <section className="relative overflow-hidden border-b border-white/10" data-testid={testId}>
    <div className="absolute inset-0">
      {image && <img src={image} alt="" className="w-full h-full object-cover opacity-40" />}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-[#09090B]" />
      <div className="absolute inset-0 grid-lines opacity-40" />
    </div>
    <div className="relative px-6 lg:px-10 pt-32 pb-24 md:pt-40 md:pb-32">
      <div className="max-w-5xl">
        {eyebrow && <div className="eyebrow mb-6">{eyebrow}</div>}
        <h1 className="font-display text-5xl sm:text-7xl md:text-8xl leading-[0.88] tracking-tighter">
          {title}
        </h1>
        {subtitle && <p className="mt-8 text-lg md:text-xl text-zinc-300 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </div>
  </section>
);
